import { RegisterApi } from "@/service/register";
import ToastV2 from "@/components/common/BaseToast";
import { clearInvitationData } from "@/util/urlUtil";
import { getUserInfoByInit } from "@/service/register/handle";
import { openLink } from "@/handle/route";
//注册请求
export const registerFormPost = (registerFormData, popupDispatch, userDispatch, onSucc) => {
  RegisterApi.postRegister(registerFormData, "email").then(res => {
    if (res.code === 0) {
      const userData = res.data;
      userDispatch({
        type: "updateUserInfo",
        payload: userData
      });
      ToastV2.success("Sign up succeeded", 2000, () => {
        popupDispatch({
          type: "closeStack"
        });
      });
      clearInvitationData();
      onSucc ? onSucc === null || onSucc === void 0 ? void 0 : onSucc() : openLink("");
    } else {
      ToastV2.error("Wrong verification code");
    }
  });
  return [];
};
//登陆请求
export const loginFormPost = async (data, popupDispatch, type, userDispatch, registerCb, onSucc) => {
  try {
    const loginRes = await RegisterApi.postLogin(data, type);
    if (loginRes.code === 0) {
      if (loginRes.data.code === 110008) {
        registerCb();
        return;
      }
      popupDispatch({
        type: "closeStack"
      });
      getUserInfoByInit(true);
      clearInvitationData();
      console.log("调试onSucc", onSucc);
      onSucc ? onSucc === null || onSucc === void 0 ? void 0 : onSucc() : openLink("");
    } else {
      ToastV2.error(loginRes.msg);
    }
  } catch (error) {
    console.log("login error", error);
  }
};
//verify handle
/**
 * @handle password verify
 */
export const passwordVerify = (password, t) => {
  const result = {
    isVerify: true,
    verifyText: ""
  };
  if (!password || password.length < 6) {
    result.isVerify = false, result.verifyText = t("Login_EmailCodeNoEmpty_Validation");
    return result;
  }
  return result;
};
/**
 * @handle email verify
 */
export const emailVerify = (email, t) => {
  const result = {
    isVerify: true,
    verifyText: ""
  };
  if (!email) {
    result.isVerify = false, result.verifyText = t("Login_EmailNoEmpty_Validation");
  } else if (!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
    result.isVerify = false, result.verifyText = t("Login_Email_Error");
  }
  return result;
};
/**
 * @handle code verify
 */
export const codeVerify = (code, t) => {
  const result = {
    isVerify: true,
    verifyText: ""
  };
  if (!code) {
    result.isVerify = false, result.verifyText = t("Login_PhoneCodeNoEmpty_Validation");
  }
  return result;
};
/**
 * @handle phone verify
 */
export const phoneVerify = (code, t) => {
  const result = {
    isVerify: true,
    verifyText: ""
  };
  if (!code) {
    result.isVerify = false, result.verifyText = t("Login_PhoneNoEmpty_Validation");
  } else if (code.length !== 11) {
    result.isVerify = false, result.verifyText = t("Login_Phone_Error");
  }
  return result;
};